import { useEffect, useState } from "react";
import api from "../../lib/api";
import DashboardLayout from "../../components/layout/DashboardLayout";
import StatusBadge from "../../components/StatusBadge";
import { formatCLP, formatUSD, formatDateTime, resolveImageUrl } from "../../lib/format";

export default function MyPurchases() {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.get("/me/purchases").then(({ data }) => setItems(data || [])).finally(() => setLoading(false));
    }, []);

    return (
        <DashboardLayout role="client">
            <div className="mb-8" data-testid="my-purchases-page">
                <div className="label-mono mb-3">/ My Purchases</div>
                <h1 className="font-heading font-black text-3xl lg:text-4xl tracking-tighter">My Purchases</h1>
                <p className="text-avx-muted mt-2">Full list of your purchases and their current status.</p>
            </div>

            {loading ? (
                <div className="text-avx-muted font-mono">Loading…</div>
            ) : items.length === 0 ? (
                <div className="panel p-10 text-center text-avx-muted">
                    You don't have any purchases yet. When the AVX Pro team registers a purchase, it will appear here.
                </div>
            ) : (
                <div className="space-y-3" data-testid="purchases-list">
                    {items.map((p) => (
                        <div key={p.id} className="panel p-5 grid md:grid-cols-[80px_1fr_auto] gap-5 items-center">
                            {p.product?.image_url ? (
                                <img src={resolveImageUrl(p.product.image_url)} alt="" className="w-20 h-20 object-cover rounded-sm border border-avx-line" />
                            ) : (
                                <div className="w-20 h-20 rounded-sm bg-avx-elevated border border-avx-line" />
                            )}
                            <div>
                                <div className="flex items-center gap-3 mb-1">
                                    <h3 className="font-heading font-bold text-lg">{p.product?.name || "—"}</h3>
                                    <StatusBadge status={p.status} testId={`purchase-status-${p.id}`} />
                                </div>
                                <div className="text-xs font-mono text-avx-muted space-x-3">
                                    <span>#{p.id.slice(0, 8)}</span>
                                    <span>·</span>
                                    <span>{formatDateTime(p.purchase_date || p.created_at)}</span>
                                    <span>·</span>
                                    <span>{p.payment_method}</span>
                                </div>
                                {p.internal_notes && (
                                    <div className="text-xs text-avx-muted mt-1 italic">{p.internal_notes}</div>
                                )}
                            </div>
                            <div className="text-right">
                                <div className="font-heading font-bold text-lg text-avx-blue">
                                    {p.currency === "USD" ? formatUSD(p.amount_paid) : formatCLP(p.amount_paid)}
                                </div>
                                <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-avx-muted">{p.currency}</div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </DashboardLayout>
    );
}
